export const ONBOARDING_SLICE_NAME = 'onboarding';

export interface OnboardingState {
  gyms: {
    filters: {
      searchText: string;
    };
  };
}

export interface OnboardingOwnState {
  onboarding: OnboardingState;
}
